import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProposePage } from '@/features/metric-hub/propose/ProposePage';

/**
 * Propose route.
 *
 * Two modes:
 *  - `/metric-hub/metrics/new` — propose a brand-new metric (default).
 *  - `/metric-hub/metrics/new?from=slug&baseVersion=N` — propose v(N+1)
 *    of an existing metric. The form pre-fills with `metric.current`,
 *    locks the basic-info section (metadata is owned by the metric, not
 *    the draft) and submits via `POST /metrics/:slug/drafts` instead of
 *    `POST /metrics` (which would try to create a new metric).
 */
export const Route = createFileRoute('/_authed/metric-hub/metrics/new')({
  validateSearch: z.object({
    from: z.string().min(1).optional(),
    baseVersion: z.coerce.number().int().positive().optional(),
  }),
  component: ProposeRoute,
});

function ProposeRoute() {
  const { from, baseVersion } = Route.useSearch();
  return <ProposePage fromSlug={from} baseVersion={baseVersion} />;
}
